export default "__VITE_ASSET__B1Qu_8at__"